import Interceptor from "@/plugins/interceptor";
const urlAPI = `${process.env.VUE_APP_URL_API}/common`;

const common = {
  state: {
    Nationalities: [],
    Countries: [],
    SelectedCountry: {
      "Id": 1,
      "Code": "AR",
      "Name": "Argentina"
    },
    SelectedCountryStates: [],
    ListStates: []
  },
  actions: {
    getNationalities({ commit }) {
      Interceptor.get(`${urlAPI}/nationalities`).then(res => {
        commit('SET_NATIONALITIES', res.data)
      })
    },
    getCountries({ commit }) {
      Interceptor.get(`${urlAPI}/countries`).then(res => {
        commit('SET_LIST_COUNTRY', res.data);
      })
    },
    SelectCountry({ commit }, id) {
      commit('UPDATE_SELECTED_COUNTRY', id)
    },
    getSelectedCountryStates({ commit }, param) {
      Interceptor.get(`${urlAPI}/countries/${param}/states`).then(res => {
        commit('SET_LIST_STATES', res.data)
      })
    }
  },
  mutations: {
    SET_LIST_COUNTRY(state, value) {
      state.Countries = value
    },
    SET_NATIONALITIES(state, value) {
      state.Nationalities = value
    },
    SET_LIST_STATES(state, value) {
      state.ListStates = value
    }
  }
}

export default common;